<template>
  <div>
    <h6 class="has-text-weight-bold mt-4 text-base text-gray-500">
      {{ value.label }} :
    </h6>
    <rating-stars :value="value.value" :config="value.config" />
  </div>
</template>

<script>
import RatingStars from './RatingStars'

export default {
  name: 'PreviewRatingAttribute',
  components: { RatingStars },
  props: ['value'],
}
</script>

<style scoped></style>
